export const declination = (
  value: number,
  words: [string, string, string],
): string => {
  const pluralRules = new Intl.PluralRules("ru-RU");
  const wordForms: Record<Intl.LDMLPluralRule, string> = {
    one: words[0],
    few: words[1],
    many: words[2],
    other: words[2],
    zero: words[2],
    two: words[1],
  };

  return `${value} ${wordForms[pluralRules.select(value)]}`;
};
